import { Component, inject } from '@angular/core';
import { Router } from '@angular/router';
import { RidSyllabicKeyboardFreeform } from '../../../../mechanics/rid-syllabic-keyboard-freeform/rid-syllabic-keyboard-freeform';

@Component({
  selector: 'app-syllabic-keyboard-plus-freeform-page',
  imports: [RidSyllabicKeyboardFreeform],
  templateUrl: './syllabic-keyboard-plus-freeform-page.html',
})
export class SyllabicKeyboardPlusFreeformPage {
  protected readonly $router = inject(Router);
}
